import { ADD_PARTNER_ACCOUNTS, ADD_PARTNER_SURVEYS, ADD_PARTNER_INVITES, CLEAR_ALL, FETCHED_PARTNER_ACCOUNTS, FETCHED_PARTNER_INVITES, FETCHING_PARTNER_ACCOUNTS, FETCHING_PARTNER_INVITES, REMOVE_PARTNER_INVITE, UPDATE_PARTNER_INVITE, FETCHED_PARTNER_SURVEYS, FETCHING_PARTNER_SURVEYS, FETCHING_POPULATION_HEALTH, FETCHED_POPULATION_HEALTH, ADD_POPULATION_HEALTH } from "../actions/constants";
import defaults from "./defaults";
import debug from "../../utilities/debug";

const partnersReducer = (state = defaults.partners, { type, payload }) => {
  switch (type) {
    case FETCHING_PARTNER_ACCOUNTS:
      return { ...state, fetchingAccounts: payload };
    case FETCHED_PARTNER_ACCOUNTS:
      return { ...state, fetchedAccounts: payload };
    case ADD_PARTNER_ACCOUNTS:
      return { ...state, list: payload.list, fetched_all_accounts: new Date() };
    case ADD_PARTNER_SURVEYS:
      return { ...state, surveys: payload };
    case FETCHING_PARTNER_INVITES:
      return { ...state, fetchingInvites: payload };
    case FETCHED_PARTNER_INVITES:
      return { ...state, fetchedInvites: payload };
    case ADD_PARTNER_INVITES:
      return { ...state, invites: payload, fetched_all_invites: new Date() };
    case UPDATE_PARTNER_INVITE:
      // Ensure payload has an id before attempting to update
      if (!payload || !payload.id) {
        debug.error('UPDATE_PARTNER_INVITE invalid payload - missing id', payload);
        return state;
      }
      // Check if invite already exists in the array
      const existingIndex = state.invites.findIndex((i) => i.id === payload.id);
      if (existingIndex !== -1) {
        // Update existing invite in place
        const updatedInvites = [...state.invites];
        updatedInvites[existingIndex] = payload;
        return { ...state, invites: updatedInvites };
      } else {
        // Add new invite only if it doesn't exist
        return { ...state, invites: [...state.invites, payload] };
      }
    case FETCHED_PARTNER_SURVEYS:
      return { ...state, fetchedPartnerSurveys: payload };
    case FETCHING_PARTNER_SURVEYS:
      return { ...state, fetchingPartnerSurveys: payload };
    case REMOVE_PARTNER_INVITE:
      return { ...state, invites: [...state.invites.filter((i) => i.id !== payload.id), payload], fetched_all_invites: new Date() };
    case FETCHING_POPULATION_HEALTH:
      return { ...state, fetchingPopulationHealth: payload };
    case FETCHED_POPULATION_HEALTH:
      return { ...state, fetchedPopulationHealth: payload };
    case ADD_POPULATION_HEALTH:
      return { ...state, populationHealth: payload };
    case CLEAR_ALL:
      return defaults.partners;
    default:
      return state;
  }
};

export default partnersReducer;